import { Button, DetailedIconBlueprint, Spacer } from '@zillow/constellation';
import {
  StyledEmptyContentBodyText,
  StyledEmptyIconContainer,
  StyledEmptySimpleCard,
  StyledEmptyStateContainer,
  StyledEmptyTitleText,
} from '../StyledComponents';

type Props = {
  setDisplayCreateNewTaskModal: (value: boolean) => void;
};

export const NoTasksEmptyState = ({ setDisplayCreateNewTaskModal }: Props) => {
  return (
    <StyledEmptySimpleCard
      isDisabled={true}
      data-testid="empty-leases-card"
      cardType="secondary"
      cardElevation={0}
      paddingX={'md'}
      paddingY={5}
    >
      <StyledEmptyStateContainer>
        <StyledEmptyIconContainer>
          <DetailedIconBlueprint />
        </StyledEmptyIconContainer>

        <StyledEmptyTitleText as="h4">Track your maintenance tasks</StyledEmptyTitleText>

        <StyledEmptyContentBodyText as="p">
          Keep track of routine or emergency repairs, and their resolutions, all in one place. Create tasks, record
          costs, add photos, and more.
        </StyledEmptyContentBodyText>

        <Spacer marginBottom="md" />

        <Button as="a" buttonType="primary" onClick={() => setDisplayCreateNewTaskModal(true)}>
          Create new task
        </Button>
      </StyledEmptyStateContainer>
    </StyledEmptySimpleCard>
  );
};
